export const MAX_STATUS_WIDTH = 451;
export const VIEWPORT_PADDING = 16;
export const PANEL_GAP = 8;
